<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
      font-weight: 400;
      color: #424242;">
        <h5><i class="fa fa-circle" style="color:#800000"></i>&nbsp; Know Your Colleague</h5>
      </div>
<div id="mainContent" class="container">
    <div class="modal-body">
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-6">
          <label class="col-form-label"
            >Enter Name of Your Colleague: </label>
          </div>
          <div class="col-sm-6">
            <select
              class="form-control form-control-sm mt-1"
              [(ngModel)]="selectName"
            >
              <option value="">Select Employee Name</option>
              <option *ngFor="let userName of userNameList" [ngValue]="userName">
                {{ userName.firstName }} {{ userName.middleName }} {{ userName.lastName }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-1"></div>
      <div class="col-sm-2">
        <button
          type="button"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="getColleaugeDetails()"
        >
          Get Details
        </button>
    </div>
    </div>
     </div>
     </div>
     
     <div class="container" id="mainContent">
      <div class="mt-5" *ngIf="user">
        <div class="row justify-content-center text-center pt-4">
          <span class="bg-theme-title"
            >P G BHAGWAT LLP, Chartered Accountants
          </span>
        </div>
        <div class="row justify-content-center text-center ">
          <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
        </div>
           
        <div class="row mt-4">
            <div class="col-md-12">
              <span class="bg-theme-title">Details of {{ selectName.firstName }} {{ selectName.middleName }} {{ selectName.lastName }} are as follows : </span>
            </div>
          </div>

          <div class="row mt-2" *ngIf="user">
            <div class="col-md-7">
              <table class="table table-bordered table-striped table-sm">
                <tbody>
                  <tr>
                    <th>Date Of Birth:</th>
                    <td *ngIf="user.userPersonalDetails != null">
                      {{ user.userPersonalDetails.dateOfBirth | date: "dd-MMM-yyyy" }}
                    </td>
                    <td *ngIf="user.userPersonalDetails == null"></td>
                  </tr>
                  <tr>
                    <th>Qualification:</th>
                    <td *ngIf="user.userPersonalDetails != null">
                      {{ user.userPersonalDetails.qualification }}
                    </td>
                    <td *ngIf="user.userPersonalDetails == null"></td>
                  </tr>
                  <tr>
                    <th>Certification:</th>
                    <td *ngIf="user.userPersonalDetails != null">
                      <span
                        *ngFor="
                          let certification of user.userPersonalDetails
                            .userCertifications
                        "
                      >
                        {{ certification.certificationType.name }} ,
                      </span>
                    </td>
                    <td *ngIf="user.userPersonalDetails == null"></td>
                  </tr>
                  <tr>
                    <th>Blood Group:</th>
                    <td *ngIf="user.userPersonalDetails != null">
                      {{ user.userPersonalDetails.bloodGroup }}
                    </td>
                    <td *ngIf="user.userPersonalDetails == null"></td>
                  </tr>
                  <tr>
                    <th>Contact Number Mobile:</th>
                    <td *ngIf="user.userPersonalDetails != null">
                      {{ user.userPersonalDetails.contactMobileNumber }}
                    </td>
                    <td *ngIf="user.userPersonalDetails == null"></td>
                  </tr>
                  <tr>
                    <th>Official Email:</th>
                    <td>{{ user.email }}</td>
                  </tr>
                  <tr>
                    <th>Personal Email-1:</th>
                    <td *ngIf="user.userPersonalDetails != null">
                      {{ user.userPersonalDetails.personalEmail }}
                    </td>
                    <td *ngIf="user.userPersonalDetails == null"></td>
                  </tr>
                  <tr>
                    <th>PAN Number:</th>
                    <td *ngIf="user.userPersonalDetails != null">
                      {{ user.userPersonalDetails.panNumber }}
                    </td>
                    <td *ngIf="user.userPersonalDetails == null"></td>
                  </tr>
                  <tr>
                    <th>Aadhar Number:</th>
                    <td *ngIf="user.userPersonalDetails != null">
                      {{ user.userPersonalDetails.aadharNumber }}
                    </td>
                    <td *ngIf="user.userPersonalDetails == null"></td>
                  </tr>
                  <tr>
                    <th>Emergency Contact Number:</th>
                    <td *ngIf="user.userPersonalDetails != null">
                      {{ user.userPersonalDetails.emergencyContactNumber1 }}
                    </td>
                    <td *ngIf="user.userPersonalDetails == null"></td>
                  </tr>
                  <tr>
                    <th>Emergency Contact Name:</th>
                    <td *ngIf="user.userPersonalDetails != null">
                      {{ user.userPersonalDetails.emergencyContactName1 }}
                    </td>
                    <td *ngIf="user.userPersonalDetails == null"></td>
                  </tr>
                  <tr>
                    <th>Emergency Contact Name-Relation:</th>
                    <td *ngIf="user.userPersonalDetails != null">
                      {{ user.userPersonalDetails.emergencyContactRelation1 }}
                    </td>
                    <td *ngIf="user.userPersonalDetails == null"></td>
                  </tr>
                  <tr>
                    <th>Permanent Address:</th>
                    <td *ngIf="user.addresses.length > 0">
                      {{ user.addresses[0].address }}
                    </td>
                    <td *ngIf="user.addresses.length == 0"></td>
                  </tr>
                  <tr>
                    <th>Permanent Address-City:</th>
                    <td *ngIf="user.addresses.length > 0">
                      {{ user.addresses[0].city ? user.addresses[0].city.name : "" }}
                    </td>
                    <td *ngIf="user.addresses.length == 0"></td>
                  </tr>
                  <tr>
                    <th>Local Address:</th>
                    <td *ngIf="user.addresses.length == 2">
                      {{ user.addresses[1].address }}
                    </td>
                    <td *ngIf="user.addresses.length == 0"></td>
                  </tr>
                  <tr>
                    <th>Local Address-City:</th>
                    <td *ngIf="user.addresses.length == 2">
                      {{ user.addresses[1].city!=null?user.addresses[1].city.name:"" }}
                    </td>
                    <td *ngIf="user.addresses.length == 0"></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-4" *ngIf="userPhoto">
              <table class="table table-bordered table-striped table-sm">
                <tbody>
                  <tr>
                    <td style="background: lightgray; text-align: center">
                      <div style="height: auto; width: 350px">
                        <img
                          [src]="userPhoto.url"
                          style="display: block; margin: 2%; width: 96%; height: auto"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
      </div>
    </div>
  </div>
